import React, { useState } from 'react'

export interface INavItemProps extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean
  indicator?: boolean
  theme?: 'default' | 'dark'
  size?: 'xs' | 'sm' | 'md' | 'lg'
  decoration?: 'dot' | 'line' | 'rounded'
  icon?: any
}

const classDecoration = {
  rounded: `after:rounded-sm
    after:h-[3px]
    after:bottom-0
    after:left-0
    after:right-0`,
  line: `after:rounded-t-sm
    after:h-[3px]
    after:bottom-0
    after:left-0
    after:right-0`,
  dot: `after:h-[6px]
    after:w-[6px]
    after:top-0
    after:bottom-0
    after:right-auto
    after:left-[-18px]
    after:m-auto
    after:rounded-t-full
    after:rounded-b-full`,
}

export const NavItem = (props: INavItemProps) => {
  const {
    children,
    active = false,
    indicator = false,
    theme = 'default',
    size = 'md',
    decoration = 'line',
    icon: Icon,
    ...divAttributes
  } = props

  const [isHover, setIsHover] = useState(false)

  return (
    <div
      {...divAttributes}
      className={`group relative flex flex-shrink cursor-pointer gap-[4px] py-[28px] after:absolute after:block after:opacity-0 after:content-[''] ${classDecoration[decoration]} ${(active || isHover) && 'after:opacity-100'} ${theme == 'dark' ? 'after:bg-default' : 'after:bg-[#3BE1BF]'} ${size == 'xs' && '!py-[3px] pb-[6px]'} ${size == 'md' && '!py-[12px]'} ${size == 'lg' && '!py-[13px]'}`}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {Icon && (
        <span
          className={`${theme == 'dark' ? `${isHover || active ? 'text-default' : 'text-focus-500'}` : `${isHover || active ? 'text-[#3BE1BF]' : 'text-white'}`}`}
        >
          <Icon
            color={
              isHover || active
                ? theme == 'dark'
                  ? '#a059ff'
                  : '#3BE1BF'
                : theme == 'dark'
                  ? '#00326d'
                  : '#FFFFFF'
            }
            className={'w-[13px]'}
          />
        </span>
      )}
      <span
        className={`relative whitespace-nowrap before:absolute before:top-0 before:bottom-0 before:right-[-16px] before:m-auto before:block before:h-[8px] before:w-[8px] before:rounded-full before:bg-[#3BE1BF] before:content-[''] ${theme == 'default' && `${active ? 'text-[#3BE1BF]' : 'text-white'} group-hover:text-[#3BE1BF]`} ${
          theme == 'dark' &&
          `${active ? 'text-default' : 'text-focus-500'} group-hover:text-default`
        } ${size == 'md' && 'text-[16px] leading-[24px]'} ${size == 'lg' && 'text-[24px] font-medium leading-[32px]'} ${!indicator && 'before:hidden'}`}
      >
        {children}
      </span>
    </div>
  )
}
